import { BaseProviderInstanceResourceModel } from '../../base-provider-instance-resource-model';
import { DriveItemPermissionRemovalDetailModel } from '../../microsoft/sharepoint/drive-item-permission-removal-detail-model';

export class DriveItemPermissionRemovalModel {
  userId: string|null;
  providerInstanceResource: BaseProviderInstanceResourceModel;
  driveId: string;
  permissions: DriveItemPermissionRemovalDetailModel[];
}
